import { createAction } from '@reduxjs/toolkit';

const base = '@CLILLC/app-settings';

export const storeDrawerOpen = createAction(`${base}/store-drawer-open`, (payload: boolean) => ({
    payload,
}));
